import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { Header } from './components/Header';
import { Footer } from './components/Footer';
import { Home } from './pages/Home';
import { Catalog } from './pages/Catalog';
import { SearchResults } from './pages/SearchResults';
import { FilmDetails } from './pages/FilmDetails';
import { Login } from './pages/Login';
import { Profile } from './pages/Profile';
import { About } from './pages/About';
import { Contact } from './pages/Contact';
import { Rights } from './pages/Rights';
import { AnimatePresence } from 'framer-motion';
function ScrollToTop() {
  const {
    pathname
  } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}
export function App() {
  return <AuthProvider data-id="element-0">
      <Router data-id="element-1">
        <ScrollToTop data-id="element-2" />
        <div className="flex flex-col min-h-screen font-sans text-[#1A1A1A] bg-[#F4F1EA]" data-id="element-3">
          <Header data-id="element-4" />
          <main className="flex-grow" data-id="element-5">
            <AnimatePresence mode="wait" data-id="element-6">
              <Routes data-id="element-7">
                <Route path="/" element={<Home data-id="element-9" />} data-id="element-8" />
                <Route path="/catalog" element={<Catalog data-id="element-11" />} data-id="element-10" />
                <Route path="/search" element={<SearchResults data-id="element-13" />} data-id="element-12" />
                <Route path="/film/:id" element={<FilmDetails data-id="element-15" />} data-id="element-14" />
                <Route path="/login" element={<Login data-id="element-17" />} data-id="element-16" />
                <Route path="/profile" element={<Profile data-id="element-19" />} data-id="element-18" />
                <Route path="/about" element={<About data-id="element-21" />} data-id="element-20" />
                <Route path="/contact" element={<Contact data-id="element-23" />} data-id="element-22" />
                <Route path="/rights" element={<Rights data-id="element-25" />} data-id="element-24" />
              </Routes>
            </AnimatePresence>
          </main>
          <Footer data-id="element-26" />
        </div>
      </Router>
    </AuthProvider>;
}